var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 1798",
    width: 533,
    height: 468,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1303)",
    d: "m0 0h57l44 7 28 7 30 10 29 13 19 10 19 12 13 9 13 10 11 9 12 11 22 22 9 11 11 14 18 27 10 17 11 23 11 27 8 27 6 25 5 33h12l42 4 28 5 29 8 22 8 25 11 17 9 17 10 10 7 18 13 13 11 11 9 18 18 7 8 11 13 10 13 9 13 13 21 12 23 11 25 8 24 8 30 6 34 2 16v51l-6 39-6 27-9 29-8 20-12 26-8 14-15 24-8 10 1 4 11 15 12 20 9 16 11 24 9 24 8 27 5 22 6 40v52l-7 44-6 26-11 33-11 25-8 16-6 11-14 22-8 11-11 14-18 20-19 19-11 9-15 12-13 9-14 9-23 13-19 9-28 11-23 7-28 6-31 4-35 3-6 38-9 34-8 23-12 27-10 20-14 22-10 14-11 14-11 13-9 9-5 6-8 7-9 9-14 11-13 10-17 11-20 12-27 13-19 8-25 8-27 7-38 6-19 2h-31l-26-3-32-5-31-8-29-10-31-14-19-11-19-12-11-8-16-13-11-9-28-28-9-11-12-15-14-21-12-20-15-31-9-24-8-26-6-28-3-20-2-24v-1118l3-31 6-31 5-19 9-27 9-21 10-21 12-20 7-11 10-14 13-16 7-8 12-13 14-14 8-7 16-13 11-8 15-10 15-9 19-10 27-12 33-11 29-7zm10 100-25 3-23 5-27 9-20 9-20 11-12 8-16 12-13 11-17 17-9 11-10 13-11 17-12 22-8 19-7 21-4 16-4 23-1 13v1116l2 21 6 29 10 30 14 29 11 18 9 12 9 11 9 10 18 18 14 11 17 12 14 8 23 12 28 10 19 5 27 4 9 1h38l25-3 19-4 22-7 16-6 17-8 18-10 17-12 13-10 12-11 16-16 9-11 9-12 9-14 14-26 8-20 8-26 4-19 3-22-5-3-25-9-26-11-22-12-20-12-15-11-13-10-14-12-15-14-11-12-7-8-12-15-11-15-14-22-13-25-10-23-11-33-6-23-5-29-2-20-1-25 99-1 1 25 4 26 5 21 10 28 10 21 15 25 13 17 12 13 7 8 13 12 11 9 30 20 22 11 20 8 19 6 30 6 17 2h39l22-3 25-5 30-10 33-16 18-12 14-10 11-10 8-7 7-7 7-8 8-9 9-12 9-14 8-14 11-23 7-19 6-22 4-23 2-22v-25l-3-28-5-25-9-27-9-21-13-23-5-8-5 2-16 11-24 14-16 8-25 11-27 9-25 6-21 4-38 4-17 1v-98l39-4 28-6 27-9 26-12 16-9 20-14 11-9 12-11 12-12 7-8 14-18 11-18 8-14 9-20 10-30 5-25 3-28v-25l-3-28-5-25-11-33-10-21-12-21-13-18-9-11-14-15-7-7-11-9-13-10-12-8-15-9-27-13-30-10-25-5-13-2-13-1h-21l-4 15-9 32-6 17-13 29-12 23-20 30-12 15-9 11-7 7-7 8-13 12-10 9-14 11-14 10-17 11-16 9-17 9-27 11-28 9-24 6-34 5-39 3v-99l25-1 35-6 21-6 27-11 16-8 18-11 13-9 13-11 8-7 22-22 9-12 10-14 9-16 10-18 10-27 7-25 4-26 1-11v-35l-3-26-5-23-11-33-9-19-12-21-10-14-10-13-11-12-18-18-20-15-15-10-26-14-25-10-24-7-22-4-19-2z",
    fill: "#1196E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1894,391)",
    d: "m0 0 5 1 11 8 11 9 14 12 16 16 7 8 11 13 10 13 9 13 13 21 12 23 11 25 8 24 8 30 6 34 2 16v51l-6 39-6 27-9 29-8 20-12 26-8 14-15 24-8 10 1 4 11 15 12 20 9 16 11 24 9 24 8 27 5 22 6 40v52l-7 44-6 26-11 33-11 25-8 16-6 11-14 22-8 11-11 14-18 20-19 19-11 9-15 12-13 9-14 9-23 13-19 9-28 11-23 7-8 2h-8v-2h-3v-2l4-3 6-2 10-5 14-5 9-2 3-2v-3l10-6h2l2-4 6-2 7-8 6-9 1-6-2-4 3-4 2-6h2l2-4 2-5 8-1 1-5 4-4h2l7-14h2l2-5 4-4 3-9 1-5-3-4 4-7 7-6 6-4-2 7 7-9 3-4 4-18-1-2-8 9-3-1-11 7h-2l-2 10-2 8-7 2-4-2-9-3-6 4-4 4h-3v2l-6 4h-8l-2 4-6 3-5 1v3h-3v2l-3-1-3 4-4 1 2-5 14-8 10-7 14-10 11-10 8-7 16-17 11-14 9-13 7-11 8-16 7-15 7-19 6-22 4-23 2-22v-25l-3-28-5-25-9-27-9-21-13-23-4-7-5 2-16 11-24 14-16 8-25 11-27 9-25 6-21 4-38 4h-17l-1-98 1-1 39-4 28-6 27-9 26-12 16-9 20-14 11-9 12-11 11-11 7-8 14-18 11-18 8-14 9-20 10-30 5-25 3-28v-25l-3-28-5-25-11-33-10-21-12-21-13-18-9-11-14-15-14-13-10-8v-2l11-1 4 4 9 5 5 5 6 4 1 2 7 3v2h2l3 6 5 3 4-1-1-9 3-1 1-3h-3v-2h-5l-1 3-2-3 4-4 4-1-5-5-2-4 3-1 1-4-2-1 1-4-7 5h-2l-1-7 5-7h3l-1-4 4-8 3-7 5-8h2l-2-8-13-13-5-3v-2h-2v-5h2l-1-4 4-2z",
    fill: "#1971FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(107,782)",
    d: "m0 0h19l19 3 16 5 16 8 15 11 11 10 11 14 9 16 1 5 649 1 1 1v86l-650 1-3 9-9 15-11 13-7 7-18 13-15 7-16 5-18 3h-20l-20-3-17-6-15-8-16-12-11-11-11-15-10-21-5-17-2-9v-30l7-25 8-17 10-15 15-16 17-12 16-8 15-5zm5 87-9 3-10 9-5 10-1 11 4 11 9 10 8 4 5 1h9l11-4 8-8 4-8 1-3v-12l-4-10-7-8-4-3-10-3z",
    fill: "#06C8BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,1105)",
    d: "m0 0h297l1 1v85l-2 1-261 1-10 10-8 7-8 8h-2v2l-8 7-9 9-8 7-7 7-8 7-11 11-8 7-12 12-8 7-8 8-8 7-2 2-194 1-14 24-9 11-14 13-14 9-16 8-18 5-13 2h-23l-22-4-13-5-15-8-11-8-10-9-11-12-10-16-8-20-3-9-2-13v-25l3-17 8-20 8-15 10-13 12-12 17-12 17-8 20-6 7-1h30l14 3 17 6 14 7 11 8 14 12 9 11 8 13 5 10v2h160l8-7 7-7 8-7 10-10 8-7 13-12 9-9 8-7 9-9h2v-2l8-7 9-9 8-7 10-10 8-7zm-396 133-10 3-9 6-6 10-1 4v13l4 10 8 8 8 4 3 1h12l9-4 8-7 5-8 1-4v-12l-4-10-7-8-10-5z",
    fill: "#06C8BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(173,413)",
    d: "m0 0h20l23 4 13 5 17 9 12 9 14 14 9 12 10 19 194 1 8 7 15 14 17 16 11 11 8 7 8 8 8 7 7 7 2 1v2l4 2 17 17 8 7 13 12 5 1 258 1v86h-298l-3-2v-2l-4-2-15-15-8-7-11-11-8-7-8-8-8-7-8-8-8-7-10-10-8-7-9-9-8-7-8-8-2-1h-160l-3 9-9 15-8 10-9 9-11 9-16 9-22 8-14 3-8 1h-16l-17-3-21-7-17-9-13-10-13-13-10-14-8-16-6-16-3-16v-26l3-17 8-20 8-15 8-10 11-12 14-11 18-10 14-5 15-3zm4 87-9 4-8 7-4 6-2 7v12l4 10 5 6 9 5 7 2h9l10-4 8-7 4-6 2-6v-13l-6-12-9-8-9-3z",
    fill: "#06C8BD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(566,53)",
    d: "m0 0 23 2 19 5 17 8 17 12 8 7 9 11 8 11 8 16 5 15 3 16v28l-4 19-6 16-5 10 2 6 13 21 12 19 14 22 24 38 8 13 6 10 2 1 124 1 1 1v86l-2 1h-171l-6-8-10-16-12-19-10-16-14-22-15-24-11-17-16-26-10-16-11 1-13 2h-12l-19-3-18-5-16-8-13-9-10-9-5-5-9-11-9-15-6-14-4-15-2-15v-17l3-19 6-18 7-14 13-18 11-11 17-12 16-8 16-5 12-2zm-2 87-9 2-8 6-6 7-4 10v9l4 11 7 8 10 5 3 1h11l10-4 8-6 5-9 1-4v-13l-6-12-8-7-6-3-5-1z",
    fill: "#06C8BD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(700,1350)",
    d: "m0 0h173l1 1v85l-2 1-123 1-6 8-9 15-16 25-13 21-28 44-9 15 2 6 7 16 5 19 1 6v28l-4 20-6 16-9 16-13 16-7 7-17 12-16 8-13 4-15 3-10 1h-15l-19-3-14-4-17-8-14-10-12-11-8-9-10-15-7-16-5-17-2-15v-17l3-20 7-20 9-16 11-14 5-5 10-9 13-9 14-7 17-5 14-3 16-1 17 2 10 2 15-23 12-20 10-15 13-21 12-19 11-17 13-21 12-19zm-139 248-9 4-8 6-4 7-3 8v9l4 10 7 8 5 4 9 3h10l10-4 8-7 4-6 2-6v-13l-4-9-7-8-10-5-4-1z",
    fill: "#06C8BD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1906,853)",
    d: "m0 0 5 1 1 7-4 5v6l1 2-3 5-2 9-8 12-2 4h-2l-2 4-5 4-1 6-4 2-3 3-4 9-9 14-5 7 1 4-1 4-5 3-1 2h-3v3l-3 1-4 9-5 7-9 4-7 6h-3l4 2-6 5-6 4-1 2-11 4-9 3-3 2-9 4-17 3-16 3 1 3 10 1v2l-19 3-30 3h-17l-1-98 1-1 39-4 28-6 27-9 26-12 10-5h5l2-2 10-1v-2l4-3h2l1-3 8-2h2l1-3 9 1v-2l4-1 1-7 4-3 5 1 3 2 7-8 4-3v-4l5-2h3l2-6z",
    fill: "#1295E3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1736,421)",
    d: "m0 0h7l10 2 14 4v2h6l9 4 9 5 5 2 1 3 5-2 9 5-4 4-10-2-19-8-22-7-25-5-1-3-4-1 4-2z",
    fill: "#1975F9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,855)",
    d: "m0 0h462l1 1v86l-4-1h2v-81l-4-3-457-1z",
    fill: "#1196E2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(749,360)",
    d: "m0 0h124l1 1v86l-2 1h-171v-1l114-1 14-2h31l4 2h9l-1-72-4-11v-1l-119-1z",
    fill: "#1296E3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(868,606)",
    d: "m0 0h6v86h-243v-1h241l1-82-5-2z",
    fill: "#1196E2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1901,397)",
    d: "m0 0 7 1 1 5 1 3 4 1 7 5v2h2v2h2v2l5 2 2 2-1 5-8-4-7-5-7-2-5-5-6-3-3-2v-2h3l-1-5z",
    fill: "#1196E2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(665,1105)",
    d: "m0 0h208l1 1v85h-1v-83l-4-1-204-1z",
    fill: "#1296E3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(851,1188)",
    d: "m0 0 8 1 2 1h10v2h-259v-1l233-1z",
    fill: "#1296E3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(700,1350)",
    d: "m0 0h173l1 1v73h-1l-1-63-2-5-2-2v-3h-168z",
    fill: "#1296E3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1837,1326)",
    d: "m0 0h2l-2 5-5 4-4 2h-4v3h-3v2l-3-1-3 4-4 1 2-5 14-8z",
    fill: "#1681F1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1873,492)",
    d: "m0 0 5 1 4 10-1 2 2 6-13-13 1-4h2z",
    fill: "#1294E3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1879,857)",
    d: "m0 0v3l-12 13h-2v2l-7 6-5 3-2-1 14-12z",
    fill: "#1196E2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1771,335)",
    d: "m0 0h8l18 5v3l-17-5-8-1z",
    fill: "#177EF3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1884,1296)",
    d: "m0 0 2 4-1 6-5 1-2-2 2-4v-3z",
    fill: "#1295E3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1822,1336)",
    d: "m0 0h2v4h-3v2l-3-1-3 4-4 1 2-5z",
    fill: "#1879F7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1830,355)",
    d: "m0 0h6l11 5v2h-5l-12-6z",
    fill: "#177CF4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1759,1458)",
    d: "m0 0 4 1 1 4h-7l-2-1-1 3-3-3z",
    fill: "#1971FC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1876,1293)",
    d: "m0 0v3l-13 13-4 1 5-5z",
    fill: "#148AEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1711,419)",
    d: "m0 0 7 2-1 3h-8l-1-3z",
    fill: "#1A71FD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1913,862)",
    d: "m0 0h2l-2 7-4 3v-7z",
    fill: "#1296E3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1902,535)",
    d: "m0 0 3 1v2l3 1 3 7 2 3-1 3-10-16z",
    fill: "#1199E0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1765,1028)",
    d: "m0 0h9l1 2-9 2-4-1z",
    fill: "#1296E3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1808,911)",
    d: "m0 0h5v2l-10 5-3-1 5-3z",
    fill: "#1975F9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1741,426)",
    d: "m0 0 12 4 1 2-11-2-6-1 4-1z",
    fill: "#1296E3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1941,1054)",
    d: "m0 0 3 4 1 7v9h-1l-3-16z",
    fill: "#1199E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColored);
export default __webpack_public_path__ + "static/media/icon_colored.6fc504bd517a121088db5e54ff75f865.svg";
export { ForwardRef as ReactComponent };